/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountingFormulaRepresentation
 */
export interface AccountingFormulaRepresentation {
    /**
     * 
     * @type {string}
     * @memberof AccountingFormulaRepresentation
     */
    expression: string;
    /**
     * 
     * @type {string}
     * @memberof AccountingFormulaRepresentation
     */
    dataProviderKey?: string;
}

/**
 * Check if a given object implements the AccountingFormulaRepresentation interface.
 */
export function instanceOfAccountingFormulaRepresentation(value: object): value is AccountingFormulaRepresentation {
    if (!('expression' in value) || value['expression'] === undefined) return false;
    return true;
}

export function AccountingFormulaRepresentationFromJSON(json: any): AccountingFormulaRepresentation {
    return AccountingFormulaRepresentationFromJSONTyped(json, false);
}

export function AccountingFormulaRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountingFormulaRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'expression': json['expression'],
        'dataProviderKey': json['dataProviderKey'] == null ? undefined : json['dataProviderKey'],
    };
}

export function AccountingFormulaRepresentationToJSON(json: any): AccountingFormulaRepresentation {
    return AccountingFormulaRepresentationToJSONTyped(json, false);
}

export function AccountingFormulaRepresentationToJSONTyped(value?: AccountingFormulaRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expression': value['expression'],
        'dataProviderKey': value['dataProviderKey'],
    };
}

